import reportError from 'util/errorReporter';
import Progress from 'redux-progress';
import { createSelector } from 'reselect';

import { CHOOSE, SEARCH } from 'modules/addon/duck/model';
import selectChosenParentOption from 'modules/addon/duck/selectors/chosenParentOption';

import selectSearchParentOption from 'modules/addon/duck/selectors/searchParentOption';
import { OrderableItem } from 'model/hams/Pricing';
import { Selector } from 'model/State';

const selectOrderableItems: Selector<Progress<OrderableItem[]>> = createSelector(
  (state) => state.addon.mode,
  selectChosenParentOption,
  selectSearchParentOption,
  (mode, chosenParentProgress, searchParentProgress) => {
    switch (mode) {
      case CHOOSE:
        return chosenParentProgress.map((parent) => (parent && parent.orderableItems) || []);
      case SEARCH:
        return searchParentProgress.map((parent) => (parent && parent.orderableItems) || []);
      default:
        reportError(`Unknown addon config mode ${mode}`);
        return Progress.none;
    }
  },
);

export default selectOrderableItems;
